import { TREATMENT_ACTIONS } from '../actions'

const initialState = {
  // List
  data: [],
  total: 1,
  params: {},
  allData: [],

  notifySuccessDeleteEncounterTreatment: null,
  notifyFailedDeleteEncounterTreatment: null,
  
  // Treatments list
  treatments: [],
  total: 0,
  page: 1,
  limit: 10,
  search: '',
  
  // Single treatment
  currentTreatment: null,
  
  // Loading states
  loading: {
    fetchTreatments: false,
    fetchTreatment: false,
    createTreatment: false,
    updateTreatment: false,
    deleteTreatment: false
  },
  
  // Error states
  errors: {
    fetchTreatments: null,
    fetchTreatment: null,
    createTreatment: null,
    updateTreatment: null,
    deleteTreatment: null
  },
  
  // Success states
  success: {
    createTreatment: false,
    updateTreatment: false,
    deleteTreatment: false
  }
}


const TreatmentReducer = (state = initialState, action) => {
  switch (action.type) {
    // Fetch treatments
    case TREATMENT_ACTIONS.FETCH_TREATMENTS_REQUEST:
      return {
        ...state,
        loading: {
          ...state.loading,
          fetchTreatments: true
        },
        errors: {
          ...state.errors,
          fetchTreatments: null
        }
      }
      
    case TREATMENT_ACTIONS.FETCH_TREATMENTS_SUCCESS:
      return {
        ...state,
        loading: {
          ...state.loading,
          fetchTreatments: false
        },
        treatments: action.payload.treatments,
        total: action.payload.total,
        page: action.payload.page,
        limit: action.payload.limit,
        search: action.payload.search,
        errors: {
          ...state.errors,
          fetchTreatments: null
        }
      }
      
    case TREATMENT_ACTIONS.FETCH_TREATMENTS_FAILURE:
      return {
        ...state,
        loading: {
          ...state.loading,
          fetchTreatments: false
        },
        errors: {
          ...state.errors,
          fetchTreatments: action.payload
        }
      }
      
    // Fetch single treatment
    case TREATMENT_ACTIONS.FETCH_TREATMENT_REQUEST:
      return {
        ...state,
        loading: {
          ...state.loading,
          fetchTreatment: true
        },
        errors: {
          ...state.errors,
          fetchTreatment: null
        }
      }
      
    case TREATMENT_ACTIONS.FETCH_TREATMENT_SUCCESS:
      return {
        ...state,
        loading: {
          ...state.loading,
          fetchTreatment: false
        },
        currentTreatment: action.payload,
        errors: {
          ...state.errors,
          fetchTreatment: null
        }
      }
      
    case TREATMENT_ACTIONS.FETCH_TREATMENT_FAILURE:
      return {
        ...state,
        loading: {
          ...state.loading,
          fetchTreatment: false
        },
        errors: {
          ...state.errors,
          fetchTreatment: action.payload
        }
      }
      
    // Create treatment
    case TREATMENT_ACTIONS.CREATE_TREATMENT_REQUEST:
      return {
        ...state,
        loading: {
          ...state.loading,
          createTreatment: true
        },
        errors: {
          ...state.errors,
          createTreatment: null
        },
        success: {
          ...state.success,
          createTreatment: false
        }
      }
      
    case TREATMENT_ACTIONS.CREATE_TREATMENT_SUCCESS:
      return {
        ...state,
        loading: {
          ...state.loading,
          createTreatment: false
        },
        treatments: [action.payload, ...state.treatments],
        total: state.total + 1,
        errors: {
          ...state.errors,
          createTreatment: null
        },
        success: {
          ...state.success,
          createTreatment: true
        }
      }
      
    case TREATMENT_ACTIONS.CREATE_TREATMENT_FAILURE:
      return {
        ...state,
        loading: {
          ...state.loading,
          createTreatment: false
        },
        errors: {
          ...state.errors,
          createTreatment: action.payload
        },
        success: {
          ...state.success,
          createTreatment: false
        }
      }
      
    // Update treatment
    case TREATMENT_ACTIONS.UPDATE_TREATMENT_REQUEST:
      return {
        ...state,
        loading: {
          ...state.loading,
          updateTreatment: true
        },
        errors: {
          ...state.errors,
          updateTreatment: null
        },
        success: {
          ...state.success,
          updateTreatment: false
        }
      }
      
    case TREATMENT_ACTIONS.UPDATE_TREATMENT_SUCCESS:
      return {
        ...state,
        loading: {
          ...state.loading,
          updateTreatment: false
        },
        treatments: state.treatments.map(treatment => (
          treatment.id === action.payload.id || treatment.uuid === action.payload.uuid ? action.payload : treatment
        )),
        currentTreatment: action.payload,
        errors: {
          ...state.errors,
          updateTreatment: null
        },
        success: {
          ...state.success,
          updateTreatment: true
        }
      }
      
    case TREATMENT_ACTIONS.UPDATE_TREATMENT_FAILURE:
      return {
        ...state,
        loading: {
          ...state.loading,
          updateTreatment: false
        },
        errors: {
          ...state.errors,
          updateTreatment: action.payload
        },
        success: {
          ...state.success,
          updateTreatment: false
        }
      }
      
    // Delete treatment
    case TREATMENT_ACTIONS.DELETE_TREATMENT_REQUEST:
      return {
        ...state,
        loading: {
          ...state.loading,
          deleteTreatment: true
        },
        errors: {
          ...state.errors,
          deleteTreatment: null
        },
        success: {
          ...state.success,
          deleteTreatment: false
        }
      }
      
    case TREATMENT_ACTIONS.DELETE_TREATMENT_SUCCESS:
      return {
        ...state,
        loading: {
          ...state.loading,
          deleteTreatment: false
        },
        treatments: state.treatments.filter(treatment => (
          treatment.id !== action.payload && treatment.uuid !== action.payload
        )),
        total: Math.max(0, state.total - 1),
        errors: {
          ...state.errors,
          deleteTreatment: null
        },
        success: {
          ...state.success,
          deleteTreatment: true
        }
      }
      
    case TREATMENT_ACTIONS.DELETE_TREATMENT_FAILURE:
      return {
        ...state,
        loading: {
          ...state.loading,
          deleteTreatment: false
        },
        errors: {
          ...state.errors,
          deleteTreatment: action.payload
        },
        success: {
          ...state.success,
          deleteTreatment: false
        }
      }
      
    // Clear errors
    case TREATMENT_ACTIONS.CLEAR_TREATMENT_ERRORS:
      return {
        ...state,
        errors: {
          fetchTreatments: null,
          fetchTreatment: null,
          createTreatment: null,
          updateTreatment: null,
          deleteTreatment: null
        }
      }
      
    // Clear success states
    case TREATMENT_ACTIONS.CLEAR_TREATMENT_SUCCESS:
      return {
        ...state,
        success: {
          createTreatment: false,
          updateTreatment: false,
          deleteTreatment: false
        }
      }
      
    // Reset state
    case TREATMENT_ACTIONS.RESET_TREATMENT_STATE:
      return {
        ...initialState
      }
    case 'GET_DATA_ENCOUNTER_TREATMENTS':
      return {
        ...state,
        allData: action.allData,
        data: action.data,
        total: action.totalPages,
        params: action.params
      }      
    case 'SUCCESS_DELETE_ENCOUNTER_TREATMENT':
      return {
        ...state, 
        notifySuccessDeleteEncounterTreatment: true
      }
    case 'FAILED_DELETE_ENCOUNTER_TREATMENT':
      return {
        ...state, 
        notifyFailedDeleteEncounterTreatment: true
      }
    case 'RESET_DELETE_ENCOUNTER_TREATMENT':
      return {
        ...state, 
        notifySuccessDeleteEncounterTreatment: null,
        notifyFailedDeleteEncounterTreatment: null
      }
    default:
      return state
  }
}
      
export default TreatmentReducer